/**
 * Financial Glance (ticker-detail-app) chrome — `/ticker/` and the
 * `/ticker-detail/` preview route.
 * `/ticker/` does not match `/ticker-detail/` (`-` follows `/ticker`).
 */
export function isFinancialGlanceTickerPath(pathname: string): boolean {
  return (
    pathname.startsWith("/ticker/") ||
    pathname.startsWith("/ticker-detail/")
  );
}

/** Company ticker paths under `/ticker/` (excludes `/ticker-detail/`). */
export function isLegacyCompanyTickerPath(pathname: string): boolean {
  return pathname.startsWith("/ticker/");
}
